import React from 'react';
import styled from 'styled-components';
import { ReportAPIResponse } from '../../ReportsBeta/api';
import TrueImpactModal, {
  modalHeightAutoStyles,
  modalRadiusStyles,
} from 'shared/design-system/components/TrueImpactModal';
import TrueImpactText from 'shared/design-system/base/TrueImpactText';
import { SPACERS } from 'shared/design-system/settings/variables/Spacers';
import { numberWithCommas } from 'shared/utils/numberUtils';
import { COLORS } from 'shared/design-system/settings/variables/Colors';

interface AllocationConfirmationDialogProps {
  reports: ReportAPIResponse[];
  handleNext: () => unknown;
  handleClose: () => unknown;
}

const StyledDiv = styled.div`
  padding: ${SPACERS.large};
  .attention {
    font-weight: bold;
    color: ${COLORS.critical};
  }
`;

const AllocationConfirmationDialog: React.FC<AllocationConfirmationDialogProps> = ({
  reports,
  handleNext,
  handleClose,
}) => {
  return (
    <TrueImpactModal
      open={true}
      maxWidth="700px"
      hideHeader={true}
      onClose={handleClose}
      addStyles={modalHeightAutoStyles + modalRadiusStyles}
      next={{
        text: 'Proceed',
        onClick: () => {
          handleNext();
          handleClose();
        },
      }}
      previous={{
        text: 'Make changes',
        onClick: handleClose,
      }}
    >
      <StyledDiv>
        <TrueImpactText>
          <span className="attention">Attention:</span> We noticed that one or
          more reports already have donations allocated to them. Are you sure
          you want to proceed with this?
        </TrueImpactText>
        <ul>
          {reports.map(r => (
            <li key={r.dbId}>
              <TrueImpactText>
                {r.program.name} ({r.year}):{' '}
                <strong>${numberWithCommas(r.totalDonations)}</strong>
              </TrueImpactText>
            </li>
          ))}
        </ul>
      </StyledDiv>
    </TrueImpactModal>
  );
};

export default AllocationConfirmationDialog;
